import { useEffect } from "react";
import { UpdateAccountErrorKeys } from "../../login/components/UpdateAccountSection";
import translate from "../functions/translate";

interface MessageProps {
    setApiErrorMessage: (value: React.SetStateAction<string | null | undefined>) => void
    apiErrorKey: UpdateAccountErrorKeys | null
    newPasswordRef: HTMLElement | null
}

export const useUpdateAccountSetMessage = (props: MessageProps) => {
    const { setApiErrorMessage, apiErrorKey, newPasswordRef } = props;

    useEffect(() => {
        const errorKeyToMessage: {
          [key in UpdateAccountErrorKeys]: string
        } = {
            inconvenience: translate("we_are_sorry_for_inconvenience_try_updating_account_later"),
            tryToLog: translate("you_can_try_login_again"),
            oneMoreTry: translate("you_have_one_more_try_reenter_username"),
            tryAgain: translate("check_information_try_again"),
            passwordGuidelines: translate("the_password_does_not_meet_required_enter_correct_info"),
        }
        setApiErrorMessage(apiErrorKey ? errorKeyToMessage[apiErrorKey] : null);
    }, [apiErrorKey, newPasswordRef, setApiErrorMessage]);
}